import { render } from "./criteria-importance.vue?vue&type=template&id=3ccf6ce5&scoped=true&ts=true"
import script from "./criteria-importance.vue?vue&type=script&lang=ts"
export * from "./criteria-importance.vue?vue&type=script&lang=ts"

import "./criteria-importance.vue?vue&type=style&index=0&id=3ccf6ce5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccf6ce5"]])

export default __exports__